<template>
  <div v-if="checkDisableInput()" :class="$style.root" class="p-2 bg-gray-100 d-flex align-items-center">
    <TextareaAutosize class="font-size-3 w-100 px-3 border-0 d-flex align-items-center bg-transparent border-0"
                      :class="$style.input"
                      :max-height="100"
                      rows="1"
                      placeholder="Escreva uma mensagem"
                      v-model="message"
                      @keydown.enter.native.prevent="send"/>
    <button class="btn-reset p-2 ml-auto" :disabled="loading" @click="send">
            <img id="mk-send" :class="[$style.icon, {[$style.loading]: isLoading}]" src="../assets/enviar-icon.svg" alt="">
    </button>
  </div>
</template>

<script>
  import { getQueryStringParams } from '../lib/utils';
  import {mapState, mapActions} from 'vuex';

  export default {
    name: 'SendMessage',
    props: {
      loading: Boolean
    },
    data() {
      return {
        message: ''
      };
    },
    computed: {
      ...mapState({
        isLoading: state => state.isSendingMessage
      })
    },
    methods: {
      ...mapActions(['sendMessage']),
      async send() {
        if (!this.message.trim().length) return;
        this.sendMessage(this.message);
        this.message = '';
      },
      checkDisableInput(){
        const params = getQueryStringParams(); 
        return params && params['disableInput'] !== 'true';
      }
    }
  }
</script>

<style lang="scss" module>
  .root {
    z-index: 1000;
    box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);
  }

  .input {
    appearance: none;

    &,
    &:focus {
      outline: none !important;
    }
  }

  .icon {
    transition: transform .3s ease-in-out;

    &.loading {
      transform: rotate(-68deg);
      animation: blinker 1s linear infinite;
    }
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
</style>
